import React from "react";
import { Button, Checkbox, Divider, Drawer, Form, Input, InputNumber, Select } from "antd";

const dados = [
  { name: "Nome", value: "usr_nome" },
  { name: "Login", value: "usr_login" },
];

const tipos = [
  { name: "Carb/Sistema", value: 0 },
  { name: "Administrador", value: 4 },
  { name: "Jornalista", value: 3 },
  { name: "Investidor", value: 7 },
];

const permissoes = [
  { name: "Correção", value: "usr_correcao" },
  { name: "Análise", value: "usr_analise" },
  { name: "Vídeo", value: "usr_video" },
  { name: "Notícias", value: "usr_noticias" },
  { name: "Editor", value: "usr_editor" },
  { name: "Excluir", value: "usr_excluir" },
];
// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)

function ModalUser(props) {
  const previewContent = props?.previewContent || {};
  const ads = previewContent.ads || {};
  const isComercial = previewContent.usr_comercial === 1;

  const updateField = (key, value) => {
    props.setPreviewContent({ ...previewContent, [key]: value });
  };

  const updateAdsField = (key, value) => {
    props.setPreviewContent({
      ...previewContent,
      ads: { ...ads, [key]: value },
    });
  };

  const toggleComercial = (checked) => {
    props.setPreviewContent({
      ...previewContent,
      usr_comercial: checked ? 1 : 0,
      ads: checked
        ? { ads_nome: previewContent.usr_nome || "", ...ads }
        : ads,
    });
  };

  return (
    <>
      <Drawer
        title={props.editing ? "Editar Usuário" : "Inserir Usuário"}
        open={props.isPreviewOpen}
        onClose={props.onRequestClose}
        placement="right"
        width={520}
        extra={
          <Button type="primary" onClick={() => props.saveData()}>
            Salvar Informações
          </Button>
        }
      >
        <Form layout="vertical">
          <Divider orientation="left" plain style={{ margin: "0 0 12px" }}>
            Dados de Acesso
          </Divider>

          {dados.map((el) => (
            <Form.Item key={el.value} label={el.name} required>
              <Input
                value={previewContent[el.value] || ""}
                onChange={(event) => updateField(el.value, event.target.value)}
                readOnly={el.value === "usr_login" && props.editing}
              />
            </Form.Item>
          ))}

          <Form.Item
            label="Senha"
            required={!props.editing}
            extra={
              props.editing
                ? "Deixe em branco para não alterar a senha atual."
                : undefined
            }
          >
            <Input.Password
              value={previewContent.usr_password || ""}
              onChange={(event) => updateField("usr_password", event.target.value)}
              placeholder={props.editing ? "••••••••" : ""}
              autoComplete="new-password"
            />
          </Form.Item>

          <Form.Item label="Tipo" required>
            <Select
              style={{ width: "100%" }}
              value={previewContent.usr_tipo}
              placeholder="Selecione"
              onChange={(value) => updateField("usr_tipo", value)}
            >
              {tipos.map((el) => (
                <Select.Option key={el.value} value={el.value}>
                  {el.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Divider orientation="left" plain style={{ margin: "4px 0 12px" }}>
            Permissões
          </Divider>

          {permissoes.map((el) => (
            <Form.Item key={el.value} label={el.name} style={{ marginBottom: 8 }}>
              <Checkbox
                checked={previewContent[el.value] === 1}
                onChange={(event) => updateField(el.value, event.target.checked ? 1 : 0)}
              />
            </Form.Item>
          ))}

          <Divider orientation="left" plain style={{ margin: "4px 0 12px" }}>
            Comercial
          </Divider>

          <Form.Item label="Usuário Comercial" style={{ marginBottom: isComercial ? 16 : 0 }}>
            <Checkbox
              checked={isComercial}
              onChange={(event) => toggleComercial(event.target.checked)}
            />
          </Form.Item>

          {isComercial && (
            <>
              <Form.Item label="Nome do Ads">
                <Input
                  value={ads.ads_nome ?? ""}
                  onChange={(event) => updateAdsField("ads_nome", event.target.value)}
                />
              </Form.Item>
              <Form.Item label="Cargo / Descrição">
                <Input
                  value={ads.ads_descricao ?? ""}
                  onChange={(event) => updateAdsField("ads_descricao", event.target.value)}
                />
              </Form.Item>
              <Form.Item label="Login no Sistema (opcional)">
                <Input
                  value={ads.ads_login_sistema ?? ""}
                  onChange={(event) => updateAdsField("ads_login_sistema", event.target.value)}
                />
              </Form.Item>
              <Form.Item label="Comissão" style={{ marginBottom: ads.ads_comissao === 1 ? 8 : 24 }}>
                <Checkbox
                  checked={ads.ads_comissao === 1}
                  onChange={(event) => updateAdsField("ads_comissao", event.target.checked ? 1 : 0)}
                />
              </Form.Item>
              {ads.ads_comissao === 1 && (
                <Form.Item label="Porcentagem de Comissão (%)">
                  <InputNumber
                    style={{ width: "100%" }}
                    min={0}
                    max={100}
                    value={ads.ads_porcentagem ?? null}
                    onChange={(value) => updateAdsField("ads_porcentagem", value)}
                  />
                </Form.Item>
              )}
              <Form.Item label="Ativo no Relatório">
                <Checkbox
                  checked={ads.ads_ativo_relatorio === 1}
                  onChange={(event) =>
                    updateAdsField("ads_ativo_relatorio", event.target.checked ? 1 : 0)
                  }
                />
              </Form.Item>
            </>
          )}
        </Form>
      </Drawer>
    </>
  );
}

export default ModalUser;
